import * as hash_stdlib from "../../stdlib/ts/stdlib";
import { EvalError } from "./EvalError";
import { buildPyodide, globalNamespaces, isPyodideLoaded, pyContextWrapper, pyStateWrapper, runPythonNamespaced, } from "./buildpython";
const loadBehavior = async (code, namespace) => {
    const wrap = `${code}\nwrap(behavior)`;
    return await runPythonNamespaced(wrap, namespace);
};
export const getBehaviorFn = async (fileName, behaviorCode) => {
    const extension = fileName.split(".").pop();
    switch (extension) {
        case "rs":
            return () => {
                throw new EvalError("Rust behavior not parsed", fileName);
            };
        case "js":
            const fn = new Function("hash_stdlib", "hstd", `${behaviorCode}\n return behavior`)(hash_stdlib, hash_stdlib);
            return (state, context) => {
                try {
                    fn(state, context);
                }
                catch (e) {
                    throw new EvalError(e, fileName);
                }
            };
        case "py":
            if (!isPyodideLoaded()) {
                await buildPyodide();
            }
            const namespace = await globalNamespaces.new(fileName);
            try {
                const pyfn = await loadBehavior(behaviorCode, namespace);
                return (state, context) => {
                    pyStateWrapper.currentState = state;
                    pyContextWrapper.context = context;
                    namespace.set("currentStep", context.step());
                    try {
                        pyfn();
                    }
                    catch (e) {
                        if (e instanceof EvalError) {
                            throw e;
                        }
                        throw new EvalError(e, fileName, true);
                    }
                };
            }
            catch (e) {
                if (e instanceof EvalError) {
                    throw e;
                }
                throw new EvalError(e, fileName, true);
            }
        default:
            throw new Error("Couldn't parse code of unknown filetype");
    }
};
//# sourceMappingURL=behavior.js.map